import type { Tenant, User, UserApi, UserGroupApi } from '../../type';

export const USER_KEYS = {
  getDetail: (id?: User['id']) =>
    id
      ? (['userApi.getDetail', id] as const)
      : (['userApi.getDetail'] as const),
  getList: (filter?: Partial<UserApi.GetList.Request>) =>
    filter ? (['userApi.getList', filter] as const) : ['userApi.getList'],
  // getList 와 prefix 를 공유해 무효화는 함께 받고, 같은 limit 의 무한 목록 캐시와는 섞이지 않게 분리합니다
  getAllList: () => ['userApi.getList', 'all'] as const,
  getCount: (filter?: Partial<UserApi.GetCount.Request>) =>
    filter ? (['userApi.getCount', filter] as const) : ['userApi.getCount'],
};

export const USER_GROUP_KEYS = {
  getList: (filter?: Partial<UserGroupApi.GetList.Request>) =>
    filter
      ? (['userGroupApi.getList', filter] as const)
      : (['userGroupApi.getList'] as const),
  getUserList: (filter?: Partial<UserGroupApi.GetUserList.Request>) =>
    filter
      ? (['userGroupApi.getUserList', filter] as const)
      : (['userGroupApi.getUserList'] as const),
  getUserCount: (filter?: Partial<UserGroupApi.GetUserCount.Request>) =>
    filter
      ? (['userGroupApi.getUserCount', filter] as const)
      : (['userGroupApi.getUserCount'] as const),
};

export const TENANT_KEYS = {
  getQuota: (tenantID?: Tenant['tenantID']) =>
    tenantID
      ? (['tenantApi.getQuota', tenantID] as const)
      : (['tenantApi.getQuota'] as const),
};
